export const packageNames = {
    TIER_ONE: "TierOne",
    TIER_TWO: "TierTwo",
    TIER_THREE: "TierThree",
};

export const externalParamPackageLabels = {
    GLASS_ONLY: "glassonly",
    STANDARD: "standard",
    PREMIUM: "premium",
};
